
/**
* 用工中心 用工结算明细
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/task/taskList' }"
        >任务列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>报名详情</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card custom-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>任务信息</span>
      </div>
      <el-row>
        <el-col :span="8">
          <el-tooltip placement="top" :content="taskInfo.merchantName || ''">
            <template #content>
              {{ taskInfo.merchantName || "" }}
            </template>
            <div class="text item ellipsis">
              用工单位：{{ taskInfo.merchantName || "" }}
            </div>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <div class="text item">任务名称：{{ taskInfo.taskName || "" }}</div>
        </el-col>
        <el-col :span="8">
          <div class="text item">
            用工周期：{{
              taskInfo.startTime && taskInfo.endTime
                ? taskInfo.startTime + "~" + taskInfo.endTime
                : ""
            }}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="text item">
            计费范围：{{
              taskInfo.minCharge && taskInfo.maxCharge && taskInfo.unitStr
                ? taskInfo.minCharge +
                  "~" +
                  taskInfo.maxCharge +
                  "元/" +
                  taskInfo.unitStr
                : ""
            }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="text item">
            结算周期：{{ taskInfo.settlementCycleStr || "" }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="text item">服务地点：{{ taskInfo.location || "" }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="text item">性别要求：{{ taskInfo.genderStr || "" }}</div>
        </el-col>
        <el-col :span="8">
          <div class="text item">
            年龄要求：{{
              taskInfo.minAge && taskInfo.maxAge
                ? taskInfo.minAge + "~" + taskInfo.maxAge + "岁"
                : ""
            }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="text item">
            任务描述：
            <el-popover placement="top" trigger="hover">
              <div style="white-space: pre-line">
                【服务内容】{{ taskInfo.content || "" }} <br />
                【计费模式】{{ taskInfo.billMode || "" }} <br />
                【服务时间】{{ taskInfo.serviceTime || "" }} <br />
                【其他福利】{{ taskInfo.otherBenefits || "" }}
              </div>
              <template #reference>
                <span style="cursor: pointer; color: #409eff" v-if="taskInfo"
                  >查看详情</span
                >
              </template>
            </el-popover>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="text item">
            任务类型：{{ taskInfo.taskTypeStr || "" }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="text item">
            学历要求：{{ taskInfo.educationLevelStr || "" }}
          </div>
        </el-col>
        <el-col :span="8" style="visibility: hidden">
          <!-- 占位用，保证布局完整 -->
          <div class="text item"></div>
        </el-col>
      </el-row>
    </el-card>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="姓名:">
        <el-input
          size="small"
          v-model="formInline.freelancerName"
          placeholder="请输入姓名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input
          size="small"
          v-model="formInline.mobile"
          placeholder="请输入手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="录用状态 :">
        <el-select
          size="small"
          v-model="formInline.status"
          placeholder="全部"
          clearable
        >
          <el-option
            v-for="(val, index) in statusList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-top: 20px; margin-bottom: 20px">
      <el-button
        size="small"
        type="primary"
        @click="batchAccept"
        :loading="batchAcceptLoading"
        >批量录用</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="openOneKeyAcceptDialog"
        :loading="oneKeyAcceptLoading"
        >一键录用</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="exportAllSettlementTemplates"
        :loading="exportAllLoading"
        >导出所有结算模板</el-button
      >
      <el-button size="small" type="primary" @click="openSpecifyDialog"
        >指定人员结算模板</el-button
      >
      <el-button size="small" @click="exportdata">导出协议</el-button>
      <el-button size="small" @click="exportPath">导出记录</el-button>
    </div>

    <!--列表-->
    <el-table
      ref="table"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        type="selection"
        :selectable="rowSelectable"
        width="60"
      >
      </el-table-column>
      <el-table-column fixed prop="freelancerName" label="姓名" width="80">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" min-width="110">
      </el-table-column>
      <el-table-column
        prop="identityDocumentNumber"
        label="证件号"
        show-overflow-tooltip
        min-width="170"
      >
      </el-table-column>
      <el-table-column
        prop="receiveAccount"
        label="收款信息"
        show-overflow-tooltip
        min-width="170"
      >
      </el-table-column>
      <el-table-column
        prop="registrationStatus"
        label="录用状态"
        min-width="80"
      >
        <template slot-scope="scope">
          {{ getStatusLabel(scope.row.registrationStatus) }}
        </template>
      </el-table-column>
      <el-table-column prop="gender" label="性别" min-width="80">
        <template slot-scope="scope">
          <!-- 调用方法获取性别对应的中文标签 -->
          {{ getGenderLabel(scope.row.gender) }}
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" min-width="80">
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        min-width="360"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            plain
            :loading="acceptLoading"
            @click="acceptRegistration(scope.row)"
            >录用</el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            :loading="rejectLoading"
            @click="rejectRegistration(scope.row)"
            >拒绝</el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            @click="openEditDialog(scope.row)"
            >更换收款信息</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="deleteRegistrationFreelancer(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <el-dialog
      :visible.sync="editDialogVisible"
      title="修改收款信息"
      width="500px"
      @close="closeEditDialog"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        size="small"
        :rules="rules"
        ref="editFormRef"
      >
        <el-form-item label="原收款账号：" style="width: 360px">
          <el-input v-model="editForm.receiveAccount" readonly></el-input>
        </el-form-item>
        <el-form-item
          label="新收款账号："
          style="width: 360px"
          prop="newReceiveAccount"
        >
          <el-input
            v-model="editForm.newReceiveAccount"
            @input="
              editForm.newReceiveAccount = editForm.newReceiveAccount.replace(
                /[^\d]/g,
                ''
              )
            "
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialogVisible = false" size="small"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveEditForm"
            size="small"
            :loading="saveEditLoading"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>

    <el-dialog
      :visible.sync="oneKeyAcceptDialogVisible"
      title="录用范围"
      @close="closeOneKeyAcceptDialog"
      width="450px"
    >
      <el-radio-group v-model="selectedRange">
        <el-radio label="current">当前页</el-radio>
        <el-radio label="all">所有页</el-radio>
      </el-radio-group>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeOneKeyAcceptDialog" size="small"
            >取消</el-button
          >
          <el-button type="primary" @click="confirmOneKeyAccept" size="small"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>

    <el-dialog
      :visible.sync="specifyDialogVisible"
      title="指定人员结算模板"
      width="500px"
      @close="closeSpecifyDialog"
    >
      <el-form
        :model="specifyForm"
        label-width="120px"
        size="small"
        ref="specifyFormRef"
        :rules="rules"
      >
        <el-form-item label="收款渠道" prop="paymentChannel">
          <el-select
            v-model="specifyForm.paymentChannel"
            placeholder="请选择收款渠道"
            style="width: 85%"
          >
            <el-option
              v-for="channel in paymentChannels"
              :key="channel.value"
              :label="channel.label"
              :value="channel.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定人员" prop="designatedPersons">
          <el-select
            v-model="specifyForm.designatedPersons"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词选择"
            :remote-method="remoteMethod"
            :loading="specifyLoading"
            style="width: 85%"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeSpecifyDialog" size="small">取消</el-button>
          <el-button
            type="primary"
            @click="submitSpecifyForm"
            size="small"
            :loading="submitSpecifyLoading"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTaskRegistration,
  updateRegistrationStatus,
  updateFreelancerAccount,
  batchUpdateRegistrationStatus,
  getallSettlementTempExcel,
  getRegistrationAgreementZip,
  getTaskRegistrationFreelancer,
} from "../../api/userMG";
import { MessageBox } from "element-ui";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      statusList: [
        {
          label: "待录用",
          value: 0,
        },
        {
          label: "已录用",
          value: 1,
        },
        {
          label: "已拒用",
          value: 2,
        },
      ],
      genderList: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      options: [],
      paymentChannels: [{ label: "银行卡", value: 1 }],
      batchAcceptLoading: false,
      oneKeyAcceptLoading: false,
      oneKeyAcceptDialogVisible: false,
      selectedRange: "current",
      exportAllLoading: false,
      saveEditLoading: false,
      acceptLoading: false,
      rejectLoading: false,
      isOverflowRef: false,
      specifyDialogVisible: false,
      specifyLoading: false,
      submitSpecifyLoading: false,
      specifyForm: {
        paymentChannel: 1,
        designatedPersons: "",
      },
      taskInfo: {},
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editDialogVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        id: "",
        receiveAccount: "", // 旧收款账号
        newReceiveAccount: "", // 新收款账号
      },
      // rules表单验证
      rules: {
        newReceiveAccount: [
          { required: true, message: "新收款账号为必填项", trigger: "blur" },
          {
            pattern: /^\d+$/,
            message: "新收款账号必须为数字",
            trigger: "blur",
          },
          { validator: this.validateNewAccount, trigger: "blur" },
        ],
        paymentChannel: [
          { required: true, message: "请选择收款渠道", trigger: "change" },
        ],
        designatedPersons: [
          { required: true, message: "请选择指定人员", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        taskId: "",
        name: "",
        mobie: "",
        status: "",
      },
      infos: {},
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.formInline.taskId = this.$route.query.id;
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    rowSelectable(row) {
      return row.registrationStatus === 0;
    },
    batchAccept() {
      const selectedRows = this.$refs.table.selection;
      if (selectedRows.length === 0) {
        MessageBox.alert("请先选择要录用的人员", "提示", {
          type: "warning",
        });
        return;
      }
      MessageBox.confirm("确定录用所有选中人员？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "question",
      })
        .then(() => {
          this.batchAcceptLoading = true;
          let selectFreelancerIds = [];
          selectedRows.forEach((row) => {
            selectFreelancerIds.push(row.id);
          });
          let parameter = {
            freelancerIds: selectFreelancerIds,
            type: "",
            status: 1,
          };
          batchUpdateRegistrationStatus(this.$route.query.id, parameter).then(
            (res) => {
              this.batchAcceptLoading = false;
              if (res.msg == "success") {
                MessageBox.alert("已成功录用所有选中人员", "提示", {
                  type: "success",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            }
          );
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    openOneKeyAcceptDialog() {
      this.oneKeyAcceptDialogVisible = true;
    },
    closeOneKeyAcceptDialog() {
      this.oneKeyAcceptDialogVisible = false;
    },
    confirmOneKeyAccept() {
      this.oneKeyAcceptLoading = true;
      let freelancerIds = [];
      if (this.selectedRange === "current") {
        // 当前页
        freelancerIds = this.listData
          .filter((row) => row.registrationStatus !== 1)
          .map((row) => row.id);

        if (freelancerIds.length === 0) {
          // 当前页没有可录用的人
          this.oneKeyAcceptLoading = false;
          this.$message.warning("当前页没有可录用的人，请检查数据后重新操作");
          this.closeOneKeyAcceptDialog();
          return;
        }

        let parameter = {
          freelancerIds: freelancerIds,
          type: "current",
          status: 1,
        };
        batchUpdateRegistrationStatus(this.$route.query.id, parameter)
          .then((res) => {
            this.oneKeyAcceptLoading = false;
            if (res.msg === "success") {
              this.$message.success("已成功录用当前页所有可录用人员");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
            this.oneKeyAcceptLoading = false;
          });
      } else {
        // 所有页
        let parameter = {
          freelancerIds: [],
          type: "all",
          status: 1,
        };
        batchUpdateRegistrationStatus(this.$route.query.id, parameter)
          .then((res) => {
            this.oneKeyAcceptLoading = false;
            if (res.msg === "success") {
              this.$message.success("已成功录用所有可录用人员");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
            this.oneKeyAcceptLoading = false;
          });
      }

      this.closeOneKeyAcceptDialog();
    },
    exportAllSettlementTemplates() {
      this.exportAllLoading = true;
      getallSettlementTempExcel(this.$route.query.id, {})
        .then((res) => {
          this.exportAllLoading = false;
          if (res.msg === "success" && res.data.downloadUrl) {
            window.open(res.data.downloadUrl, "_blank");
          } else {
            MessageBox.alert(res.msg || "导出失败，请稍后重试", "提示", {
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.exportAllLoading = false;
          MessageBox.alert("导出失败，请稍后重试", "提示", {
            type: "error",
          });
        });
    },
    openSpecifyDialog() {
      this.specifyDialogVisible = true;
      this.options = [];
      this.specifyForm.designatedPersons = [];
    },
    closeSpecifyDialog() {
      this.specifyDialogVisible = false;
    },
    remoteMethod(query) {
      if (query === "") {
        this.options = [];
        return;
      }
      this.specifyLoading = true;
      let params = {
        taskId: this.$route.query.id,
        freelancerName: query,
      };
      getTaskRegistrationFreelancer(params).then((res) => {
        this.specifyLoading = false;
        if (res.msg == "success") {
          this.options = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    submitSpecifyForm() {
      this.submitSpecifyLoading = true;
      if (
        !this.specifyForm.designatedPersons ||
        this.specifyForm.designatedPersons.length === 0
      ) {
        this.submitSpecifyLoading = false;
        MessageBox.alert("请选择指定人员", "提示", {
          type: "error",
        });
        return;
      }

      const params = new URLSearchParams();
      this.specifyForm.designatedPersons.forEach((person) => {
        params.append("designatedPersons", person);
      });

      // 发送请求到后端
      getallSettlementTempExcel(this.$route.query.id, params)
        .then((res) => {
          this.submitSpecifyLoading = false;
          if (res.msg === "success" && res.data.downloadUrl) {
            window.open(res.data.downloadUrl, "_blank");
            this.closeSpecifyDialog();
          } else {
            MessageBox.alert(res.msg || "导出失败，请稍后重试", "提示", {
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.submitSpecifyLoading = false;
          MessageBox.alert("导出失败，请稍后重试", "提示", {
            type: "error",
          });
        });
    },
    validateNewAccount(rule, value, callback) {
      if (value === this.editForm.receiveAccount) {
        callback(new Error("新收款账号和旧收款账号一致，请检查数据"));
      } else {
        callback();
      }
    },
    exportdata() {
      MessageBox.confirm("确定导出所有协议？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 用户点击确定，调用后端接口触发协议导出
          getRegistrationAgreementZip(this.$route.query.id, {})
            .then((res) => {
              // 处理导出结果
              if (res.msg === "success") {
                MessageBox.alert(
                  "协议正在导出，请在导出记录中查看进度",
                  "提示",
                  {
                    type: "success",
                  }
                );
              } else {
                MessageBox.alert(
                  res.msg || "协议导出失败，请稍后重试",
                  "提示",
                  {
                    type: "error",
                  }
                );
              }
            })
            .catch((error) => {
              MessageBox.alert("协议导出失败，请稍后重试", "提示", {
                type: "error",
              });
            });
        })
        .catch(() => {
          // 用户点击取消，不做任何操作
        });
    },
    exportPath() {
      this.$router.push({
        path: "/task/registrationExportList",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    // 获取公司列表
    getdata(params) {
      this.loading = true;
      getTaskRegistration(params).then((res) => {
        this.loading = false;
        if (res.msg == "success") {
          this.listData = res.data.items;
          this.taskInfo = res.data.taskInfo;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    reset() {
      (this.formInline = {
        page: 1,
        pageSize: 10,
        taskId: this.$route.query.id,
        name: "",
        mobie: "",
        status: "",
      }),
        this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {},
    getStatusLabel(status) {
      const item = this.statusList.find((item) => item.value === status);
      return item ? item.label : "未知状态";
    },
    getGenderLabel(gender) {
      const item = this.genderList.find((item) => item.value === gender);
      return item ? item.label : "";
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },

    deleteRegistrationFreelancer(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let parameter = {
            status: 9, // 删除
          };
          updateRegistrationStatus(this.$route.query.id, row.id, parameter)
            .then((res) => {
              this.loading = false;
              if (res.msg == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 录用方法
    acceptRegistration(row) {
      this.acceptLoading = true;
      let parameter = {
        status: 1, // 录用
      };
      updateRegistrationStatus(this.$route.query.id, row.id, parameter)
        .then((res) => {
          this.acceptLoading = false;
          if (res.msg == "success") {
            this.$message({
              type: "success",
              message: "录用成功",
            });
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.acceptLoading = false;
        });
    },
    // 拒绝方法
    rejectRegistration(row) {
      this.rejectLoading = true;
      let parameter = {
        status: 2, // 拒绝
      };
      updateRegistrationStatus(this.$route.query.id, row.id, parameter)
        .then((res) => {
          this.rejectLoading = false;
          if (res.msg == "success") {
            this.$message({
              type: "success",
              message: "拒绝成功",
            });
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.rejectLoading = false;
        });
    },
    openEditDialog(row) {
      this.editDialogVisible = true;
      // 复制当前行的数据到编辑表单
      this.editForm = { ...row };
    },
    // 关闭编辑、增加弹出框
    closeEditDialog() {
      this.editDialogVisible = false;
    },
    saveEditForm() {
      this.$refs.editFormRef.validate((valid) => {
        if (valid) {
          this.saveEditLoading = true;
          let parameter = {
            newReceiveAccount: this.editForm.newReceiveAccount,
            receiveAccount: this.editForm.receiveAccount,
          };

          updateFreelancerAccount(this.editForm.id, parameter)
            .then((res) => {
              this.saveEditLoading = false;
              if (res.msg === "success") {
                this.closeEditDialog();
                this.$message({
                  type: "success",
                  message: "更改成功",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.saveEditLoading = false;
            });
        } else {
          // 表单验证失败，给出提示
          this.$message({
            type: "error",
            message: "表单验证失败，请检查输入",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.m-bott-15 {
  margin-bottom: 15px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.custom-card {
  margin-top: 20px;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>





// WEBPACK FOOTER //
// src/views/task/registrationDtl.vue